export default {
  WEB: 1,
  CLUB: 2,
  TERMINAL: 3,
};
